module.exports = __webpack_public_path__ + "img/BR.02842ea5.svg";